import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faTrash } from '@fortawesome/free-solid-svg-icons';
import { PartnerDomainProps } from './types';
import { styles } from './styles';
import { Button } from '@v2/components';
import { DeleteConfirmationModal } from '@v2/features';

const PartnerDomain: React.FC<PartnerDomainProps> = ({ domain, onDelete }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleConfirmDelete = () => {
    setConfirmOpen(false);
    onDelete(domain.id);
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.info}>
          <FontAwesomeIcon icon={faGlobe} className={styles.icon} />
          <span className={styles.name}>{domain.name}</span>
        </div>
        <Button
          variant="ghost-danger"
          size="sm"
          onClick={() => setConfirmOpen(true)}
          aria-label={`Delete ${domain.name}`}
          icon={<FontAwesomeIcon icon={faTrash} />}
        />
      </div>

      <DeleteConfirmationModal
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirmDelete}
      />
    </>
  );
};

export default PartnerDomain;
